import React, { useCallback, useState } from 'react';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';
import { CustomLabelChip } from './CustomLabelChip';
import { CustomLabelSelectorPopper } from './CustomLabelSelectorPopper';

type UpdateCustomLabelProps = {
  updateCustomLabel: (customLabel: CustomLabel, position: number) => void;
  removeCustomLabel: (position: number) => void;
  label: CustomLabel;
  position: number;
  fieldName: string;
};
export const UpdateCustomLabel: React.FC<UpdateCustomLabelProps> = ({
  updateCustomLabel,
  removeCustomLabel,
  label,
  position,
  fieldName
}: UpdateCustomLabelProps) => {
  const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined);
  const open = Boolean(anchorEl);

  const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(undefined);
  }, []);

  const onLabelUpdate = useCallback(
    (customLabel: CustomLabel) => {
      updateCustomLabel(customLabel, position);
    },
    [position, updateCustomLabel]
  );
  const onRemoveLabel = useCallback(() => {
    removeCustomLabel(position);
  }, [position, removeCustomLabel]);

  return (
    <>
      <CustomLabelChip
        label={label}
        onClick={handleClick}
        onDelete={onRemoveLabel}
        onAcceptSuggestion={onLabelUpdate}
      />
      {open && (
        <CustomLabelSelectorPopper
          open
          actionType="update"
          anchorEl={anchorEl}
          handleClose={handleClose}
          onChange={onLabelUpdate}
          customLabel={label}
          fieldName={fieldName}
        />
      )}
    </>
  );
};
